import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1e7979e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create_modal" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "line" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_name" }, "头像：", -1))
const _hoisted_5 = { class: "line" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_name" }, "姓名：", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_name" }, "内容：", -1))

import { ref, watch, unref } from 'vue';
import { message } from 'ant-design-vue';
import CUpload from '@/components/CUpload.vue';
import { FileInfo } from '../Sensitive/sensitive';
import { ICreateD } from './type';

interface IProp {
  createModalType: number;
  modelValue: ICreateD;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateModal',
  props: {
    createModalType: null,
    modelValue: null
  },
  emits: ['updata:data'],
  setup(__props: any, { emit }) {

const props = __props as {
  createModalType: number;
  modelValue: ICreateD;
};


const data = ref<ICreateD>({
  avatal: '',
  avatalId: 0,
  content: '',
});
data.value = unref(props.modelValue);

const fileList = ref([]);
const loading = ref(false);
const handleChang = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    data.value.avatal = info.file?.response?.data.url;
    data.value.avatalId = info.file?.response?.data.id;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  data.value.avatal = '';
  data.value.avatalId = 0;
};


watch(
  () => props.modelValue,
  () => {
    data.value = unref(props.modelValue);
  }
);
watch(data.value, () => {
  emit('updata:data', data.value);
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.createModalType >= 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createVNode(CUpload, {
                "file-list": fileList.value,
                "handle-change": handleChang,
                "image-name": data.value.avatal,
                loading: loading.value,
                "click-stop": imageDel,
                class: "line_upload"
              }, null, 8, ["file-list", "image-name", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_a_input, {
              value: data.value.content,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.value.content) = $event)),
              placeholder: "请输入内容"
            }, null, 8, ["value"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_a_input, {
              value: data.value.content,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((data.value.content) = $event)),
              placeholder: "请输入内容"
            }, null, 8, ["value"])
          ])
        ]))
  ]))
}
}

})